/** @format */
import { Component, ViewEncapsulation } from '@angular/core';
import { NavigationTab } from 'sis-components';

@Component({
    selector: 'app-payments-and-grants-tabs',
    templateUrl: './payment-and-grant-tabs.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class PaymentAndGrantTabsComponent {
    readonly tabs: NavigationTab[] = [
        {
            path: 'student.logged-in.profile.payments-and-grants.payments',
            id: 'payments-and-grants-payments-tab',
            title: 'PROFILE.PAYMENTS.TAB_TITLE',
        },
        {
            path: 'student.logged-in.profile.payments-and-grants.grants',
            id: 'payments-and-grants-grants-tab',
            title: 'PROFILE.GRANTS.TAB_TITLE',
        },
    ];
}
